import _extends from "@babel/runtime/helpers/extends";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/core/components/Forms/FormInput.js",
  _this = this;
import React, { useContext, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { FormFieldContext } from './FormField';
import { withTheme } from '../../ThemeProvider';
import { isDefined } from '../../../helpers';
import { responsiveStyles } from '../../../core/utils/responsiveStyles';
var animation = keyframes([""]); // TODO Sudhir: Add documentation specific to this component.

var FormInputComponent = function FormInputComponent(props, ref) {
  var _useContext = useContext(FormFieldContext),
    _onFocus = _useContext.onFocus,
    _onBlur = _useContext.onBlur,
    value = _useContext.value,
    setValue = _useContext.setValue;
  var _onChange = props.onChange;
  useLayoutEffect(function () {
    setValue(isDefined(props.value) ? props.value : props.defaultValue);
  }, [props.defaultValue, props.value]);
  var handleOnkeyUp = function handleOnkeyUp(e) {
    if (props.type !== 'number') return;
    var isInvalidKeycodes = function () {
      if (e.location !== 0) return false; // approve function keys (general keys = 0)

      if (e.keyCode === 8 || e.keyCode === 13) return false; // approve Delete and Return keys

      if (e.keyCode >= 37 && e.keyCode <= 40) return false; // approve navigation keys

      if (e.keyCode < 48 || e.keyCode > 57) return true; // not allowed non-numeric keys

      return false;
    }();
    if (isInvalidKeycodes) e.preventDefault();
  };
  function handleAnimationEvent(e) {
    // Fix: to handle autoFill
    // Ref Issue: https://github.com/mui-org/material-ui/issues/22488#issuecomment-687293183
    // Ref Code: https://github.com/mui-org/material-ui/blob/a927c9f842cbebed7edffe58dee51f08e0ad8054/packages/material-ui/src/InputBase/InputBase.js#L401
    if (e.animationName === animation.getName()) setValue(true);
  }
  var handleOnPaste = function handleOnPaste(e) {
    var type = props.type,
      onPaste = props.onPaste;
    if (type === 'number') {
      var val = e.clipboardData.getData('text/plain');
      var isNum = /^\d+$/.test(val);
      if (!isNum) e.preventDefault();
    } else if (typeof onPaste === 'function') {
      onPaste();
    }
    return;
  };
  return /*#__PURE__*/React.createElement(StyledInput, _extends({}, props, {
    value: props.value || props.value === '' ? props.value : value,
    ref: ref,
    autoComplete: props.autoComplete,
    onKeyUp: handleOnkeyUp,
    onPaste: handleOnPaste,
    onMouseDown: handleMouseDown,
    onAnimationStart: handleAnimationEvent,
    onChange: function onChange(e) {
      setValue(e.target.value);
      return _onChange && _onChange(e);
    },
    onFocus: function onFocus(e) {
      if (props.disabled) return;
      _onFocus(e);
      props.onFocus && props.onFocus(e);
    },
    onBlur: function onBlur(e) {
      if (props.disabled) return;
      _onBlur(e);
      props.onBlur && props.onBlur(e);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 5
    }
  }));
};
var handleMouseDown = function handleMouseDown(e) {
  return e.stopPropagation();
};
var FormInput = /*#__PURE__*/React.forwardRef(FormInputComponent);
FormInput.propTypes = {
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};
var StyledInput = withTheme(styled.input.withConfig({
  displayName: "FormInput__StyledInput",
  componentId: "sc-6yh7yy-0"
})(["&&&{background-color:transparent;border-radius:8px;border:none;box-sizing:border-box;color:", ";font-family:", ";", " ", " ", ";", " line-height:1.5;outline:none;transition:all 0.2s ease-in-out;width:100%;z-index:0;resize:none;padding:0;margin:0;appearance:textfield;&:-webkit-autofill{animation-duration:5000s;animation-name:", ";}&::-ms-clear{display:none;height:0;width:0;}&::-ms-reveal{display:none;}", " ", " ::-webkit-inner-spin-button,::-webkit-calendar-picker-indicator{display:none;-webkit-appearance:none;}::placeholder{color:", ";transition:all 0.2s ease-in-out 0.1s;}::-ms-input-placeholder{color:", ";transition:all 0.2s ease-in-out 0.1s;}::-webkit-input-placeholder{color:", ";transition:all 0.2s ease-in-out 0.1s;}::-moz-placeholder{color:", ";transition:all 0.2s ease-in-out 0.1s;}&:not(:focus)::placeholder{color:", ";transition:all 0.2s ease-in-out 0s;}&:not(:focus)::-ms-input-placeholder{color:", ";transition:all 0.2s ease-in-out 0s;}&:not(:focus)::-webkit-input-placeholder{color:", ";transition:all 0.2s ease-in-out 0s;}&:not(:focus)::-moz-placeholder{color:", ";transition:all 0.2s ease-in-out 0s;}}"], function (p) {
  return p.disabled ? p.coreTheme.cl_ter_l3 : p.coreTheme.cl_ter_base;
}, function (_ref) {
  var _coreTheme$inputText$, _coreTheme$inputText;
  var coreTheme = _ref.coreTheme;
  return (_coreTheme$inputText$ = (_coreTheme$inputText = coreTheme.inputText) === null || _coreTheme$inputText === void 0 ? void 0 : _coreTheme$inputText.fontFamily) !== null && _coreTheme$inputText$ !== void 0 ? _coreTheme$inputText$ : coreTheme.ff_sec_thin;
}, function (_ref2) {
  var _coreTheme$inputText2, _coreTheme$inputText3;
  var coreTheme = _ref2.coreTheme;
  return (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$inputText2 = coreTheme.inputText) === null || _coreTheme$inputText2 === void 0 ? void 0 : _coreTheme$inputText2.height) && css(["height:", ";"], coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$inputText3 = coreTheme.inputText) === null || _coreTheme$inputText3 === void 0 ? void 0 : _coreTheme$inputText3.height);
}, function (_ref3) {
  var _coreTheme$inputText4, _coreTheme$inputText5;
  var coreTheme = _ref3.coreTheme;
  return (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$inputText4 = coreTheme.inputText) === null || _coreTheme$inputText4 === void 0 ? void 0 : _coreTheme$inputText4.caretColor) && css(["caret-color:", ";"], coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$inputText5 = coreTheme.inputText) === null || _coreTheme$inputText5 === void 0 ? void 0 : _coreTheme$inputText5.caretColor);
}, function (_ref4) {
  var _coreTheme$inputText6;
  var coreTheme = _ref4.coreTheme;
  return Object.assign({}, responsiveStyles({
    fontSize: ((_coreTheme$inputText6 = coreTheme.inputText) === null || _coreTheme$inputText6 === void 0 ? void 0 : _coreTheme$inputText6.fontSize) || coreTheme.fs_xl
  }, coreTheme));
}, function (_ref5) {
  var _coreTheme$inputText7, _coreTheme$inputText8;
  var coreTheme = _ref5.coreTheme;
  return (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$inputText7 = coreTheme.inputText) === null || _coreTheme$inputText7 === void 0 ? void 0 : _coreTheme$inputText7.fontWeightFormInput) && css(["font-weight:", ";"], coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$inputText8 = coreTheme.inputText) === null || _coreTheme$inputText8 === void 0 ? void 0 : _coreTheme$inputText8.fontWeightFormInput);
}, animation, function (p) {
  var _p$coreTheme$inputTex, _p$coreTheme, _p$coreTheme$inputTex2;
  return p.as === 'input' && css(["", ";"], responsiveStyles({
    height: (_p$coreTheme$inputTex = (_p$coreTheme = p.coreTheme) === null || _p$coreTheme === void 0 ? void 0 : (_p$coreTheme$inputTex2 = _p$coreTheme.inputText) === null || _p$coreTheme$inputTex2 === void 0 ? void 0 : _p$coreTheme$inputTex2.heightFormInput) !== null && _p$coreTheme$inputTex !== void 0 ? _p$coreTheme$inputTex : [30]
  }, p.coreTheme));
}, function (p) {
  return p.as === 'textarea' && css(["overflow:auto;"]);
}, function (_ref6) {
  var coreTheme = _ref6.coreTheme;
  return coreTheme.cl_ter_l3;
}, function (_ref7) {
  var coreTheme = _ref7.coreTheme;
  return coreTheme.cl_ter_l3;
}, function (_ref8) {
  var coreTheme = _ref8.coreTheme;
  return coreTheme.cl_ter_l3;
}, function (_ref9) {
  var coreTheme = _ref9.coreTheme;
  return coreTheme.cl_ter_l3;
}, function (p) {
  return p.alwaysShowAsHint ? p.coreTheme.cl_ter_l3 : 'transparent';
}, function (p) {
  return p.alwaysShowAsHint ? p.coreTheme.cl_ter_l3 : 'transparent';
}, function (p) {
  return p.alwaysShowAsHint ? p.coreTheme.cl_ter_l3 : 'transparent';
}, function (p) {
  return p.alwaysShowAsHint ? p.coreTheme.cl_ter_l3 : 'transparent';
}));
export default FormInput;